export default __webpack_public_path__ + "static/media/46.5ab37a72.jpeg";